"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var AppContext = /*#__PURE__*/_react["default"].createContext({
  messages: {},
  labels: {},
  titles: {},
  routes: {},
  menus: {},
  userStatusManager: null,
  storage: function storage() {},
  template: null,
  style: {}
});
var _default = AppContext;
exports["default"] = _default;